import type { ComponentPropsWithRef } from 'react';

import { assignInlineVars } from '@vanilla-extract/dynamic';

import { clsx } from '~/styles/utils';

import { innerColorStyles, innerStyle, spinnerSize, spinnerSizeStyles, spinnerStyle } from './Spinner.css';

type Props = ComponentPropsWithRef<'span'> & {
  color?: 'default' | 'currentColor';
  size: number | 'inline';
};

export const Spinner = ({ color = 'currentColor', size, ...delegated }: Props) => {
  const sizeVars = typeof size === 'number' ? assignInlineVars({ [spinnerSize]: `${size}px` }) : undefined;

  return (
    <span
      {...delegated}
      className={clsx(spinnerStyle, size === 'inline' ? spinnerSizeStyles.inline : spinnerSizeStyles.fixed, delegated.className)}
      style={{ ...sizeVars, ...delegated.style }}
    >
      <span className={clsx(innerStyle, innerColorStyles[color])} />
    </span>
  );
};
